import { useAuth } from "../auth/useAuth";

/**
 * Header de la app. Muestra branding + nombre de usuario + logout.
 *
 * En Fase futura agregamos UsageBadge (consumo del día) y posible
 * link al panel admin.
 */
export function Header() {
  const { user, logout } = useAuth();

  // user es el JWT parseado: tiene sub, email, preferred_username,
  // given_name, family_name, etc. (lo que Keycloak haya emitido)
  const displayName =
    user?.preferred_username || user?.email || "Usuario";

  return (
    <header style={styles.header}>
      <div>
        <h1 style={styles.title}>🛍 Conócelo</h1>
        <p style={styles.subtitle}>
          Investiga antes de comprar
        </p>
      </div>
      <div style={styles.userBox}>
        <span style={styles.username}>{displayName}</span>
        <button style={styles.logoutBtn} onClick={logout}>
          Cerrar sesión
        </button>
      </div>
    </header>
  );
}

const styles = {
  header: {
    background: "#1a1a2e",
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#c8c3ff",
  },
  title: {
    fontSize: "20px",
    margin: 0,
    fontWeight: 600,
  },
  subtitle: {
    fontSize: "12px",
    margin: "2px 0 0",
    color: "#7a74b0",
  },
  userBox: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontFamily: "sans-serif",
    fontSize: "13px",
  },
  username: {
    color: "#9990d8",
  },
  logoutBtn: {
    background: "transparent",
    border: "1px solid #3a3860",
    color: "#9990d8",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "12px",
    fontFamily: "sans-serif",
  },
};
